import { formatNumber } from "@uicore";
import { default as NoAutoSaveImage } from "@/assets/images/no_auto_save.svg?react";
import { useAppState } from "@/modules/app/useAppContext";
import styles from "../../styles.module.scss";

interface NoAutoSaveProps {
  estimatedSavings: number;
}

const NoAutoSave = ({ estimatedSavings }: NoAutoSaveProps) => {
  const { currency } = useAppState();
  return (
    <div className={styles.no_auto_save}>
      <NoAutoSaveImage />
      <div className={styles.side_content}>
        <div className={styles.saving}>
          {formatNumber(estimatedSavings, { currency })}
          <div className={styles.text}>per year</div>
        </div>
        <div className="text-muted">
          You are throwing away per year down the drain by not enabling auto-management of the
          warehouse.
        </div>
      </div>
    </div>
  );
};

export default NoAutoSave;
